var cafe_marker = "//www.swisswater.com/cdn/shop/t/13/assets/location-marker-coffee-shop.svg?v=55194568759398680491750755954";
var grocery_marker = "//www.swisswater.com/cdn/shop/t/13/assets/location-marker-grocery.svg?v=97248029777396235061750755954";

const mapStyle = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#e7e7e5"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#abbfd0"
            },
            {
                "visibility": "on"
            }
        ]
    }
];

function distance(lat1, lon1, lat2, lon2) {
  var p = 0.017453292519943295;    // Math.PI / 180
  var c = Math.cos;
  var a = 0.5 - c((lat2 - lat1) * p)/2 +
          c(lat1 * p) * c(lat2 * p) *
          (1 - c((lon2 - lon1) * p))/2;

  return (7917.6 * Math.asin(Math.sqrt(a))).toFixed(1);
}

function getLocations() {
  $.ajax({
      type: "GET",
      url: "//www.swisswater.com/cdn/shop/t/13/assets/locations.csv?v=64566685760824063911750755955",
      dataType: "text",
      success: function(data) { processData(data); }
   });
}

function processData(allText) {

  var allTextLines = allText.replace(/Caff�/g, 'Caffé').replace(/Caf�/g, 'Café').replace(/Coffee�/g, 'Coffee®').replace(/"/g, '').split(/\r\n|\n/);
  var headers = allTextLines[0].split(',').map(h => h.toLowerCase());
  var locations = [];
  var categories = [];
  for (var i=1; i<allTextLines.length; i++) {
    var row = allTextLines[i].split(',');
    var category = row[headers.indexOf('categories')];
    if (categories.indexOf(category) < 0) {
      categories.push(category);
    }
    if (
      category !== 'Green Coffee Broker' &&
      category !== 'Grocery' &&
      category !== 'Online'
    ) {
      locations.push({
        storeid: `loc_${i}`,
        lat: parseFloat(row[headers.indexOf('latitude')]),
        lng: parseFloat(row[headers.indexOf('longitude')]),
        address: ((row[headers.indexOf('address')] || '') + (
          row[headers.indexOf('city')] ? ', ' + row[headers.indexOf('city')] : ''
        ) + (
          row[headers.indexOf('prov/state')] ? ', ' + row[headers.indexOf('prov/state')] : ''
        ) + (
          row[headers.indexOf('postal/zip code')] ? ', ' + row[headers.indexOf('postal/zip code')] : ''
        )),
        street_addr: (row[headers.indexOf('address')] || ''),
        url: row[headers.indexOf('url')],
        category,
        name: row[headers.indexOf('store')],
        brands: row[headers.indexOf('brands')] ? row[headers.indexOf('brands')] : ''
      });
    }
  }
  console.log({categories});
  initMap(locations);
}

function initMap(locations) {
  var user = {lng: -122.3321, lat: 47.6062}
  // Create the map.
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: 10,
    center: user,
    styles: mapStyle,
    disableDefaultUI: true,
  });
// Add custom zoom buttons
  const zoomControlsDiv = document.createElement('div');
  zoomControlsDiv.classList.add('zoom-controls');
  map.controls[google.maps.ControlPosition.TOP_LEFT].push(zoomControlsDiv);

  const zoomInButton = document.createElement('button');
  zoomInButton.textContent = '+';
  zoomInButton.classList.add('zoom-in');
  zoomControlsDiv.appendChild(zoomInButton);

  const zoomOutButton = document.createElement('button');
  zoomOutButton.textContent = '-';
  zoomOutButton.classList.add('zoom-out');
  zoomControlsDiv.appendChild(zoomOutButton);

  // Zoom in and zoom out functionality
  zoomInButton.addEventListener('click', function () {
    map.setZoom(map.getZoom() + 1);
  });

  zoomOutButton.addEventListener('click', function () {
    map.setZoom(map.getZoom() - 1);
  });

  var geocoder = new google.maps.Geocoder();
  $('#search-map').click(function() {
    var address = $("#search-input").val();
    if (address) {
      geocoder.geocode( { 'address': address}, function(results, status) {
        if (status == 'OK') {
          var geo = results[0].geometry.location;
          user.lng = geo.lng();
          user.lat = geo.lat();
          map.setCenter(geo);
          setMarkers();
        } else {
          alert('Geocode was not successful for the following reason: ' + status);
        }
      });
    }
  })

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        user = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        map.setCenter(user);
      },
      () => {
        console.log('geolocation not supported');
      }
    );
  }

  var stores = [];
  var markers = [];

  var oldcenter = new google.maps.LatLng(0,0);

  var infowindow = new google.maps.InfoWindow();

  google.maps.event.addListener(map, 'click', function() {
      infowindow.close();
  });

  function setMarkers() {
    var bounds =  map.getBounds();
    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();
    var minx = sw.lng();
    var maxx = ne.lng();
    var miny = sw.lat();
    var maxy = ne.lat();

    var newStores = locations.filter(loc => (
      loc.lng > minx &&
      loc.lng < maxx &&
      loc.lat > miny &&
      loc.lat < maxy
    ));

    for (let i = 0; i < markers.length; i++) {
      var loc = markers[i];
      var visible = map;
      if (
        loc.lng < minx ||
        loc.lng > maxx ||
        loc.lat < miny ||
        loc.lat > maxy
      ) {
        visible = null;
      }
      markers[i].setMap(visible);
    }

    if (newStores !== stores) {
      stores = newStores.map(store => ({
        ...store,
        dist: distance(store.lat, store.lng, user.lat, user.lng)
      })).sort((a, b) => a.dist - b.dist);
      $('#results').html('');
      for (let i = 0; i < stores.length; i++) {
        const loc = stores[i];
        const content = `<div class='info-window'>
          <p class='title'>${loc.name}</p>
          <div class='loc'>
            <p class='address'>${loc.address}</p>
            <p class='distance'>${loc.dist} miles</p>
          </div>
          ${loc.url ? `<a class='url cafe-locator-result' href="https://${loc.url.replace('https://', '').replace('http://', '')}" target="_blank">${loc.url}</a>` : ''}
          ${loc.brands ? (
            `<div>
              <p class='available'>Available roasters at location:</p>
              <div class='roasters'>
                <p class='brand'>${loc.brands}</p>
              </div>
            </div>`
            ) : ''}

        </div>`;

        var icon = cafe_marker;

        const marker = markers.find(m => m.storeid === loc.storeid) ||
          new google.maps.Marker({
            position: { lat: loc.lat, lng: loc.lng },
            map,
            title: loc.name,
            icon,
            storeid: loc.storeid,
            storetype: loc.category
          });

        if (!markers.find(m => m.storeid === loc.storeid)) {
          markers.push(marker);
        }

        $('#results').append(`<div class='result' id='${loc.storeid}'>
          <div class='marker'>
            <img src="${icon}"/>
          </div>
          <div class='details'>
            <p class='title'>${loc.name}</p>
            <p class='address'>
              ${loc.street_addr}
              <span class='distance'>${loc.dist} miles</span>
            </p>
          </div>
        </div>`);
        $('#results').on('click', `#${loc.storeid}`, function() {
          $('#results').find('.selected').removeClass('selected');
          if (!$(this).hasClass('selected')) {
            $(this).addClass('selected');
          }
          infowindow.close();
          infowindow.setContent(content);
          infowindow.open(map, marker);
        });

        google.maps.event.addListener(marker, 'click', (function(marker, content) {
            return function() {
                infowindow.setContent(content);
                infowindow.open(map, marker);
            }
        })(marker, content));
      }
    }
  }

  google.maps.event.addListener(map, 'idle', function() {
    var newcenter = map.getCenter();
    var newc = { lng: newcenter.lng(), lat: newcenter.lat() };
    var old = { lng: oldcenter.lng(), lat: oldcenter.lat() };

    if (
      Math.abs(newc.lng - old.lng) > 0.1 ||
      Math.abs(newc.lat - old.lat) > 0.1
    ) {
      oldcenter = newcenter;
      setMarkers();
    }
   });

}
